import { httpClient } from '@texas/api/httpClient/httpClient';

export interface CustomsCodeItem {
  id: number;
  branchId: number;
  identifier: string;
  name: string;
  archived: boolean;
}

export const customsCodesApi = {
  getAll: () => httpClient.get<CustomsCodeItem[]>('garp/customscodes/all'),
};
